import { RichTextRenderer } from "~/components/RichTextRenderer";
import { cn } from "~/lib/utils";

type TestimonialProps = {
  stars?: number;
  quote: string;
  name: string;
  role: string;
  companyLogo?: string;
  avatar?: string;
  align?: "left" | "center";
  orientation?: "stacked" | "inline";
};

export function Testimonial({
  stars = 5,
  quote,
  name,
  role,
  companyLogo,
  avatar,
  align = "center",
  orientation = "inline",
}: TestimonialProps) {
  return (
    <section
      className={cn(
        "max-w-2xl mx-auto py-8",
        align === "center" && "text-center"
      )}
    >
      <div className={cn("flex mb-4", align === "center" && "justify-center")}>
        {Array.from({ length: stars }).map((_, i) => (
          <svg
            key={i}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            className="w-5 h-5 text-black"
          >
            <path d="M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
          </svg>
        ))}
      </div>

      <blockquote className="text-lg sm:text-xl text-gray-800 font-medium mb-6">
        “{<RichTextRenderer richText={quote} />}”
      </blockquote>

      <div
        className={cn(
          "flex gap-4",
          align === "center" && "justify-center items-center",
          orientation === "inline" ? "flex-row" : "flex-col"
        )}
      >
        {avatar && (
          <img
            src={avatar}
            alt={name}
            className="w-12 h-12 rounded-full object-cover bg-gray-200"
          />
        )}
        <div className="text-left text-sm">
          <div className="font-semibold">{name}</div>
          <div>{role}</div>
        </div>

        {/* Trennlinie */}
        {orientation === "inline" ? (
          <div className="h-12 w-0.5 bg-black mx-2" />
        ) : null}

        {companyLogo && (
          <img
            src={companyLogo}
            alt={"Company Logo"}
            className="h-12 w-fit object-contain"
          />
        )}
      </div>
    </section>
  );
}
